import type { AddRelatedDocumentsModalHandlers } from './useRelatedDocumentsPanelHandlers.types';

import { useEffect } from 'react';

export const useRelatedDocumentsPanelLifecycles = ({
  onDefaultExpandedTypeChange
}: {
  onDefaultExpandedTypeChange: AddRelatedDocumentsModalHandlers['handleDefaultExpandedTypeChange'];
}) => {
  useEffect(onDefaultExpandedTypeChange, [onDefaultExpandedTypeChange]);
};
